module.exports = __webpack_public_path__ + "static/img/default_img2@2x.70d56a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wxbind/default_img2@2x.png
// module id = o+Wb
// module chunks = 1